export default __webpack_public_path__ + "static/media/189.6280eb6e.png";